const DEVICE_ID_KEY = 'mh_device_id'

let cachedDeviceId: string | null = null

/** Mã thiết bị ổn định theo trình duyệt (localStorage) — để lần theo thao tác cùng một máy. */
function getWebDeviceId(): string {
  if (cachedDeviceId) return cachedDeviceId
  try {
    const saved = localStorage.getItem(DEVICE_ID_KEY)
    if (saved) {
      cachedDeviceId = saved
      return saved
    }
    const created =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
    const id = `web-${created}`
    localStorage.setItem(DEVICE_ID_KEY, id)
    cachedDeviceId = id
    return id
  } catch {
    return 'web-unknown'
  }
}

/** Header nhận diện client cho lịch sử hoạt động (muahang-backend `common/client-info.ts`). */
export function getClientInfoHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'X-Client-Platform': 'WEB',
    'X-Client-App': 'muahang-web',
    'X-Device-Id': getWebDeviceId(),
    'X-Client-Screen': encodeURIComponent(window.location.pathname),
  }
  const version = process.env.REACT_APP_VERSION
  if (version) headers['X-Client-Version'] = version
  return headers
}
